export interface AttachmentTypeType {
    id: number;
    name: string;
    ordering: number;
    deleted: boolean;
}

export interface AttachmentType {
    created?: string | null;
    id: number | null;
    uuid?: string;
    file: string | null;
    filename: string | null;
    reference: string | null;
    attachment_type: number | null;
    deal: number | null;
    proposal: number | null;
    order: number | null;
    job: number | null;
    invoice: number | null;
    contract: number | null;
    contact: number | null;
    location: number | null;
    email_template: number | null;
    visibility: string | null;
    deleted: boolean;
}

export const createNewAttachment = ({ 
    id, 
    uuid, 
    file, 
    fileName, 
    dealId,
    proposalId,
    orderId,
    jobId,
    invoiceId,
    contractId,
    contactId,
    locationId,
    emailTemplateId,
}: {
    id?: number | null,
    uuid?: string,
    file: string,
    fileName: string,
    dealId?: number,
    proposalId?: number,
    orderId?: number,
    jobId?: number,
    invoiceId?: number,
    contractId?: number,
    contactId?: number,
    locationId?: number
    emailTemplateId?: number,
}): AttachmentType => ({
    id: id ?? null,
    uuid: uuid,
    file: file ?? null,
    filename: fileName ?? null,
    reference: null,
    attachment_type: null,
    deal: dealId ?? null,
    proposal: proposalId ?? null,
    order: orderId ?? null,
    job: jobId ?? null,
    invoice: invoiceId ?? null,
    contract: contractId ?? null,
    contact: contactId ?? null,
    location: locationId ?? null,
    email_template: emailTemplateId ?? null,
    visibility: null,
    deleted: false,
})

export interface NewAttachment {
    file: File;
    filename: string;
}

export interface AttachmentDetailListProps {
    detailPageId: string;
    detailPage: string;
}

export type AttachmentUpdateType = {
    filename?: string,
    attachment_type?: number | null,
    visibility?: string,
    deleted?: boolean,
}

export const acceptedFileTypes = ['.pdf', '.xls', '.xlsx', '.doc', '.docx', '.ppt', '.pptx', '.png', '.jpeg', '.jpg', '.heic', '.heif'];

export interface Signature {
    id: number;
    created: string;
    modified: string;
    file: string;
    filename: string;
    signer_name: string | null;
    signer_email: string | null;
    signed_by: 'field_worker' | 'client';
    signed_by_user_id: number | null;
    signed_by_user_full_name: string | null; 
    job_id: number | null;
    appointment_id: number | null;
    deleted: boolean;
}